<template>
    <div class="ItemList" >
        <div v-for="(item,index) in tableData" class="tableData1" :key="index" @click="TenderAnnouncement(item)">
          <div style="width: 1200px;margin: 0 auto;" class="tableData" >
          <div style="margin-bottom: 10px;">
            <span style="font-weight: 600; font-size: 18px;margin-right: 10px;cursor: pointer;" class="mainColor" v-if="item.biddingType==1">[ {{ getStatus('sys_section_stauts',item.sectionStauts) }} ]</span>
            <span style="font-weight: 600;font-size: 18px;margin-right: 10px;cursor: pointer;" class="mainColor" v-else>[ {{ getStatus('sys_section_stauts_tenders',item.sectionStauts) }} ]</span>
            <span style="font-size: 18px;font-weight: 600;margin-right: 10px;cursor: pointer;"  >{{locale=='en'?item.sectionNameEn:locale=='lo'?item.sectionNameLo: item.sectionName}}</span>
            <span style="color: #999999;float: right;">{{ item.createTime }}</span>
          </div>
          <span class="biddingType" :style="{background:item.biddingType==1?'#FDF6EC':'#ECF6FF', color:item.biddingType==1?'#E6A23C':'#409EFF'}">
            <span>{{ $t('view.类型') }}</span><span style="margin: 0 5px;">|</span><span>{{ item.biddingType==1?$t('view.询价'):$t('view.招标') }}</span>
          </span>
          <div class="line" style="margin-top: 10px;">
            <div v-if="item.projectPrice" style="width: 300px;">{{$t('view.预计金额')}}：<span >{{ getStatus('sys_currency',item.currency,'remark') }}{{ formatNum(item.projectPrice)}} {{ locale=='en'?item.moneyUnitEn:locale=='lo'?item.moneyUnitLo: item.moneyUnit }}</span></div>
            <div v-if="item.securityDeposit">{{$t('view.竞标保证金')}}：<span > {{ getStatus('sys_currency',item.currency,'remark') }}{{ formatNum(item.securityDeposit) }}</span></div>
          </div>
          <div class="line">
            <div>{{$t('view.招标单位')}}：<span>{{ item.organization }}</span></div>
          </div>
          <div class="line">
            <div v-if="item.biddingType!=1">{{$t('view.技术联系人/电话')}}：<span>{{ item.technicalContacts}} / {{item.technicalPhoneNumber }}</span></div>
            <div v-else>{{$t('view.联系人/电话')}}：<span>{{ item.businessContacts}} / {{item.businessPhoneNumber }}</span></div>
          </div>
          <div class="line">
            <div>{{$t('view.截止时间')}}：<span>{{ item.biddingType==0?item.signupEndTime:item.entTime }}</span></div>
          </div>
        </div>
      </div>
        <el-pagination v-if="total" style="text-align: center;margin-top: 10px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination> 
        <div v-if="!tableData.length&&Loading" style="text-align: center;padding: 200px 0;">
          <img src="../assets/empty.png">
          <div>{{ $t('view.没有找到相关项目') }}</div>
        </div>
      </div>
  </template>
    
<script>
import {getDicts} from '@/api/index'
  export default {
    data(){
      return{
        tableData:[],
        total:0,
        sys_section_stauts:[],
        sys_section_stauts_tenders:[],//招标的项目状态
        sys_currency:[],//金额
        Loading :false,
        sys_section_type:[],
        locale: localStorage.getItem('locale')||'zh',

      }
    },
    created(){
      this.getDicts('sys_section_type')
      this.getDicts('sys_section_stauts')
      this.getDicts('sys_currency')
      this.getDicts('sys_section_stauts_tenders')
    },
    methods: {
      // 招标详情
      TenderAnnouncement(item){
          let routeUrl= this.$router.resolve({
              path: item.biddingType==0?'TenderAnnouncement':'InquiryAnnouncement',
              query: {id:item.sectionId}
          })
          window.open(routeUrl.href, '_blank');
      },
      // 字典
      getDicts(type){
          getDicts(type).then(res=>{
              res.data.map(item=>{
                  item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
              })
              this[type]=res.data
          })
      },
      // 分页
      handleCurrentChange(e){
        this.$parent.homeListPage(e)
      }
    },
    };
  </script>
<style lang="scss" scoped>
.biddingType{
  border-radius: 2px;
  padding: 3px 10px;
  font-size: 15px;

}
.line{
  display: flex;
  line-height: 35px;
  div{
    color: #999999;
  }
  span{
    color: #333333;
  }
}
.tableData{
  padding: 20px 0;
  border-bottom: solid 1px $Border-color;
}
.tableData1:hover{
  background: #F6F6F6;
  cursor: pointer;
}
// .tableData:last-child{border: none;}
</style>